import SiteCards from "../components/registration/SiteCards.vue";
import Vue from 'vue';
import $ from 'jquery';
import client from 'lib/axios';
import { camelizeKeys } from 'humps';

let siteCardsVm: InstanceType<typeof Vue>;

const getSiteCards = () => {
  return siteCardsVm ? siteCardsVm.$children[0] as any : undefined;
}

// jQueryで実装された大学選択等のUIと vue.js で作られた同時登録サイト選択UIを無理やり連携させるために
// Vue のルートインスタンスからコンポーネントを取り出してメソッドを直接呼ぶ
const updateSiteCards = async () => {
  const siteCards = getSiteCards();
  if (siteCards == null) return;

  const universityId: string | undefined = $('.js-registration-university:visible').val();
  const manualUniversity: string | undefined = $('.js-registration-manual-university:visible').val();
  const graduateYear: string = $('.js-registration-graduate-year').val();
  const hasUniversity = (manualUniversity != null && manualUniversity !== '') || (universityId != null && universityId !== '');
  const course: string | null = $('.js-registration-course:checked').val();
  if (hasUniversity && graduateYear != null && graduateYear !== '' && course != null) {
    const { data } = await client.get('/users/site_registrations', {
      params: {
        university_id: universityId,
        manual_university: manualUniversity,
        graduate_year: graduateYear,
        course
      }
    });
    siteCards.setSites(camelizeKeys(data));
  } else {
    siteCards.setSites([]);
  }
}

const initLegacyUI = () => {
  const $elems = $('.js-registration-university, .js-registration-graduate-year, .js-registration-manual-university, .js-registration-course');
  if ($elems.length == 0) return;

  $elems.change(() => {
    updateSiteCards();
  });
  updateSiteCards();
};

const getProps = () => {
  const elem = document.getElementById('js-site-cards');
  if (elem == null) return;
  const dataIds = elem.dataset.checkedSiteIds;
  return {
    initialCheckedSiteIds: dataIds ? JSON.parse(dataIds) : [],
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const props = getProps();
  if (props == null) return;

  const vm = new Vue({
    el: '#js-site-cards',
    render: h => h(SiteCards, { props })
  });
  siteCardsVm = vm;

  initLegacyUI();
});
